module.exports = __webpack_public_path__ + "static/desktop/img/visa-curved-128px.c6e25c1c.png";